package fr.arcplex.network.model

import fr.arcplex.network.http.Serializer
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.contentOrNull

data class CoherenceProgramContents(
    val uuid: String = "",
    val ref: Int = 0,
    val title: String = "",
    val originalTitle: String = "",
    val synopsis: String = "",
    val duration: String = "",
    val durationMinutes: Int = 0,
    val year: String = "",
    val csa: String = "",
    val csaLabel: String = "",
    val genres: List<String> = emptyList(),
    val casting: List<String> = emptyList(),
    val director: List<String> = emptyList(),
    val images: CoherenceImages = CoherenceImages(),
    val actions: CoherenceActions = CoherenceActions(),
    val rails: Map<String, Rail> = emptyMap(),
    val rawDataJson: String = ""
) {
    fun get(key: String): String? {
        val obj = runCatching { Serializer.json.parseToJsonElement(rawDataJson) as? JsonObject }.getOrNull()
            ?: return null
        val value = obj[key] ?: return null
        return when (value) {
            is JsonPrimitive -> value.contentOrNull
            else -> value.toString()
        }
    }
}

data class CoherenceImages(
    val backdrop: String = "",
    val poster: String = ""
)

data class CoherenceActions(
    val play: Boolean = false,
    val trailer: Boolean = false,
    val wishlist: Boolean = false
)
